import { z } from 'zod';

const PanelId = z.string().min(1);
const ClientId = z.string().min(1);
const BereitAnfrage = z.object({ panelId: PanelId, clientId: ClientId.optional() }).strict();
const GoneAnfrage = z.object({ panelId: PanelId, clientId: ClientId }).strict();
const BereitAntwort = z.object({ ok: z.literal(true), panelId: PanelId, ownerRecorded: z.boolean() }).strict();
const GoneAntwort = z.object({ ok: z.literal(true), panelId: PanelId, owners: z.number().int().min(0) }).strict();

async function sende<T>(url: string, body: unknown, schema: z.ZodType<T>, keepalive = false): Promise<T> {
  const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body), keepalive, signal: AbortSignal.timeout(8_000) });
  if (!response.ok) throw new Error(`${url} fehlgeschlagen: HTTP ${response.status}`);
  return schema.parse(await response.json());
}

/** Validierte Besitzmeldung fuer die headless steuerbaren Browserpanels. */
export async function meldeBrowserPanelBereit(panelId: string, clientId?: string): Promise<void> {
  const body = BereitAnfrage.parse({ panelId, clientId });
  await sende('/api/browser-panel/ready', body, BereitAntwort);
}

/** Validierte, beim Aushaengen weiter transportierbare Besitzabmeldung. */
export async function meldeBrowserPanelFort(panelId: string, clientId: string): Promise<void> {
  const body = GoneAnfrage.parse({ panelId, clientId });
  await sende('/api/browser-panel/gone', body, GoneAntwort, true);
}
